import React from 'react'
import { Portal } from 'react-portal'

import { AccessLevelSelect } from '../AccessLevelSelect'
import {
  AccessLevelSelectInvite,
  LinkIcon,
  InvitePeopleInputWrapper,
  LinkInviteInput,
  CopyButton,
} from './PublicPermissions.styles'
import Spinner from 'components/Spinner'
import { Flex } from 'components/Box'
import { usePublicPermissions } from './usePublicPermissions'
import { ShareListItemFragment } from 'gqlTypes'
import ConfirmationDialog from 'components/ConfirmationDialog'

interface PublicPermissionsProps {
  share: Pick<
    ShareListItemFragment,
    | 'identifier'
    | 'publicUrl'
    | 'publicAccessLevel'
    | 'publicCommentsEnabled'
    | 'userCanUpdateCommentsEnabled'
    | 'name'
  >
}

const PublicPermissions = ({ share }: PublicPermissionsProps) => {
  const {
    loading,
    getSelectProps,
    getConfirmDialogProps,
    confirmDialogOpen,
  } = usePublicPermissions({ share })

  return (
    <>
      <Flex data-testid="public-link-permissions">
        <InvitePeopleInputWrapper mr={3} disabled>
          <LinkIcon />
          <LinkInviteInput type="text" value={share.publicUrl} disabled />
          <Flex ml="auto">
            {loading && <Spinner.Flex mr={2} primary />}
            <AccessLevelSelectInvite>
              <AccessLevelSelect {...getSelectProps()} />
            </AccessLevelSelectInvite>
          </Flex>
        </InvitePeopleInputWrapper>
        <CopyButton showIcon={false} value={share.publicUrl} />
      </Flex>
      {confirmDialogOpen && (
        <Portal>
          <ConfirmationDialog
            {...getConfirmDialogProps()}
            confirmButton={{
              ...getConfirmDialogProps().confirmButton,
              text: 'Restrict Access',
            }}
            title="Restrict Access?">
            Public users will no longer have access to ”{share.name}” until you
            make it public again.
          </ConfirmationDialog>
        </Portal>
      )}
    </>
  )
}

export default PublicPermissions
